FeedbackController.$inject = ['$scope', '$uibModalInstance', 'Club', '$location', 'alerts'];

/* @ngInject */
function FeedbackController($scope, $uibModalInstance, Club, $location, alerts) {
    var vm = this;
    vm.title = 'FeedbackController';
    vm.close = function () {
        $uibModalInstance.close(false);
    };

    vm.loading = false;
    vm.options = [
        {id: 'suggestion', name: 'Sugerencia', placeholder: '¿Qué te gustaría que mejoremos?'},
        {id: 'error', name: 'Reportar un error', placeholder: 'Explicanos brevemente qué pasó'},
    ];
    vm.selected = vm.options[0];
    vm.comment = '';

    vm.submit = function () {
        if ($scope.feedback.$invalid) {
            return;
        }

        vm.loading = true;
        Club.API.customPOST({
            type: vm.selected.id,
            comment: vm.comment,
            url: $location.$$path,
        }, 'feedback')
            .then(function () {
                alerts.success('Exito', 'Gracias por tu ayuda! Seguiremos mejorando');
                $uibModalInstance.close(true);
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading = false;
            });
    };

    activate();

    ////////////////

    function activate() {
    }
}

export default FeedbackController;